<template>
  <div class="supporters">
    <div class="head row align-center column-s">
      <h1>SUPPORTERS</h1>
      &nbsp;&nbsp;&nbsp;
      <Button :layout="showForm ? 'red-go' : 'green-go'" title="NOVO SUPPORTER" @click="showForm = !showForm">{{
        showForm ? "x" : "+"
      }}</Button>
      <transition name="slide">
        <div v-if="showForm" class="new grid-11">
          <SupporterForm :form="form" />
        </div>
      </transition>
    </div>
    <div class="filters row wrap">
      <div class="grid-2 grid-12-s"><label>Nome</label><input @keyup.enter="load()" class="input" v-model="filter.nome" placeholder="Nome" />
      </div>
      <div class="grid-2 grid-12-s"><label>E-mail</label><input @keyup.enter="load()" class="input" v-model="filter.email"
          placeholder="E-mail" /></div>
      <div class="grid-1 grid-12-s"><label>Estado</label><select v-model="filter.estado">
          <option value="">Selecione</option>
          <option v-for="uf in estados" :value="uf.sigla" :key="uf.nome">{{ uf.nome }}</option>
        </select></div>
      <div class="grid-2 grid-12-s"><label>Cidade</label><input @keyup.enter="load()" class="input" v-model="filter.cidade"
          placeholder="Cidade" /></div>
      <div class="grid-2 grid-12-s col"><label>CPF</label><input @keyup.enter="load()" class="input" v-model="filter.cpf" placeholder="CPF" />
      </div>
      <div class="grid-2 grid-12-s col"><label>CNPJ</label><input @keyup.enter="load()" class="input" v-model="filter.cnpj" placeholder="CNPJ" />
      </div>
      <div class="grid-1 grid-12-s row align-end">
        <Button layout="green-go grid-12-s" @click="load" :loader="loader"><i class="fa fa-search" />BUSCAR</Button>
      </div>
    </div>
    <div class="list" v-if="list.length>0 || loader">
      <div v-if="loader" class="column align-center justify-center">
        <Loader layout="small" />
      </div>
      <template v-else>
        <div class="container">
          <div class="head row justify-space">
            <div class="grid-1">ID</div>
            <div class="grid-2">Nome</div>
            <div class="grid-3">E-mail</div>
            <div class="grid-2">Celular</div>
            <div class="grid-2">Criado</div>
            <div class="grid-2">Alterado</div>
            <div class="grid-2"></div>
          </div>
          <div class="content">
            <div v-for="(item, i) of list" :key="'item' + i">
              <div class="line row justify-space align-center" @click.stop="toggle(i)">
                <div class="grid-1">{{ item.id }}</div>
                <div class="grid-2">{{ item.nome }}</div>
                <div class="grid-3">{{ item.email }}</div>
                <div class="grid-2">{{ item.celular | phone }}</div>
                <div class="grid-2">{{ item.criado_em | date }}</div>
                <div class="grid-2">{{ item.alterado_em | date }}</div>
                <div class="grid-2 row justify-end controls">{{ item.status }}&nbsp;&nbsp;
                  <button @click="getHistoric(item.id)" class="icons row align-center">
                    <i class="fa fa-list" title="Histórico" />
                    Histórico
                  </button>
                  <button @click="getFiles(item.id)" class="icons row align-center">
                    <i class="fa fa-file" title="Arquivos" />
                    Arquivos
                  </button>
                  <!-- <button @click="openContract(item)" class="icons row align-center">
                    <i class="fa fa-file-contract" title="Contrato" />
                    Contrato
                  </button> -->
                </div>
              </div>
              <div v-if="item.show" class="edit row wrap column-s">
                <SupporterForm v-if="item.info" :form="item.info" />
                <Loader layout="small" v-else />
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <Modal :modal="modal">
      <div class="historic" v-if="modal.mod == 'historic'">
        <div class="title row">
          <div class="grid-2">ID</div>
          <div class="grid-7">Histórico</div>
          <div class="grid-3">Criado</div>
        </div>
        <div class="line row align-center" v-for="item of historic.list" v-bind:key="item.id">
          <div class="grid-2">{{ item.id }}</div>
          <div class="grid-7">{{ item.historico }}</div>
          <div class="grid-3" style="min-width: 160px"><b>{{ item.criado_em | date }}</b> por {{ item.nome_criado_por }}
          </div>
        </div>
      </div>
      <div class="historic files" v-if="modal.mod == 'files'">
        <div class="title row">
          <div class="grid-3">Enviado</div>
          <div class="grid-6">Arquivo</div>
          <div class="grid-3">Data Validação</div>
        </div>

        <div class="line row align-center" v-for="item of files.list" v-bind:key="item.criado_em">
          <div class="grid-3">{{ item.criado_em | date }}</div>
          <div class="grid-6"><a :href="`/portal/arquivo/${item.id}/doutor/${item.id_doutor}`" target="_blank">{{
            item.descricao
          }}</a></div>
          <div class="grid-3">{{ item.dh_validacao | date }}
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>

import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import Modal from "@/components/Modal.vue";
import SupporterForm from "@/views/admin/components/SupporterForm.vue";
import format from '@/utils/format'
import estados from '../../../public/json/cidades.json'

var initForm = {
  nome: "",
  cpf: "",
  rg: "",
  dt_nascimento: "",
  sexo: "",
  pcd: "",
  email: "",
  fone: "",
  celular: "",
  cep: "",
  cidade: "",
  logradouro: "",
  numero: "",
  bairro: "",
  estado: "",
  complemento: "",
  cnpj: "",
  razao_social: "",
  ns_community: "",
  id_banco: "",
  agencia_banco: "",
  dv_agencia_banco: "",
  conta_banco: "",
  tipo_conta: "",
  operacao_conta: "",
  titular_conta: "",
};

export default {
  name: "Supporters",
  components: {
    Button,
    SupporterForm,
    Loader,
    Modal
  },
  data() {
    return {
      estados: estados,
      filter: { cidade: "", estado: "", nome: "", email: "", cpf: "", cnpj: "" },
      loader: false,
      showForm: false,
      historic: {
        mod: 'historic',
        title: "Histórico Supporter",
        show: true,
        callback: () => this.historic.show = true,
        list: []
      },
      files: {
        mod: 'files',
        title: "Arquivos do Supporter",
        show: true,
        callback: () => this.files.show = true,
        list: []
      },
      termo: {},
      modal: {},
      list: [],
      search: "",
      form: { send: this.create, ...initForm },
    };
  },
  methods: {
    ...mapActions("admin", ["SUPPORTERS_FILES", "SUPPORTERS_LIST", "SUPPORTERS_GET", "SUPPORTERS_NEW", "SUPPORTERS_DEL", "SUPPORTERS_UPDATE", "SUPPORTERS_UPDATE_STATUS", "SUPPORTERS_HISTORIC"]),
    async load() {
      this.loader = true;
      //let filter = this.filter.length ? { [this.filter]: this.search } : {}
      await this.SUPPORTERS_LIST(this.filter).then(({ data }) => this.list = data || [])
      this.loader = false
    },
    getHistoric(ID) {
      this.SUPPORTERS_HISTORIC(ID).then(({ data }) => {
        if (data && data.length) {
          this.historic = { ...this.historic, list: data } || []
          this.modal = { ...this.historic }
        }
      });
    },
    getFiles(ID) {
      this.SUPPORTERS_FILES({ id_doutor: ID, ignora_nota_fiscal: true }).then(({ data }) => {
        if (data && data.length) {
          this.files = { ...this.files, list: data } || [];
          this.modal = { ...this.files }
        }
      })
    },
    clearForm(form) {
      form.celular = format.clear(form.celular)
      form.fone = format.clear(form.fone)
      form.cep = format.clear(form.cep)
      form.cpf = format.clear(form.cpf)
      form.cnpj = format.clear(form.cnpj)
      form.dt_nascimento = format.date(form.dt_nascimento)
      return form
    },
    async create(form) {
      form = await this.clearForm(form)
      return this.SUPPORTERS_NEW(form).then(({ status }) => {
        if (status == 201 || status == 200) {
          this.form = {
            ...{ send: this.create },
            ...initForm,
          };
          this.load();
          this.showForm = false;
        }
      });
    },
    del(item) {
      return this.SUPPORTERS_DEL(item.id).then(() => this.load());
    },
    async update(item) {
      item = await this.clearForm(item)
      this.SUPPORTERS_UPDATE({ ...item, params: item.id }).then(({ status }) => (status == 200 || status == 201) && this.load());
    },
    async update_status(ID) {
      this.SUPPORTERS_UPDATE_STATUS(ID).then(({ status }) => (status == 200 || status == 201) && this.load());
    },

    async toggle(index) {
      this.list[index].show = !this.list[index].show;

      if (this.list[index].show) {
        await this.SUPPORTERS_GET(this.list[index].id).then(({ data }) => {
          this.list[index].info = data || {};
          this.list[index].info.update = true;
          this.list[index].info.send = (form) => this.update(form);
          this.list[index].info.updateStatus = (form) => this.update_status(form);
          this.list[index].info.del = (form) => this.del(form);
          this.list = [...this.list];
        });
      } else this.list = [...this.list];
    },

    async openContract(supporter) {
      this.modal = {
        show: true,
        id_doutor: supporter.id,
        title: "Contrato Supporter",
        layout: "ContratoAdmin",
      }
      /*      if (supporter.dh_aceite_termo) {
             window.open('/TermoSupporter.html', '_blank')
           } else alert('Supporter ainda não aceitou os termos') */
    }

  },
  mounted() {
    this.$parent.$children[0].changeMenu("supporters");
    //this.load()
  }
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.supporters
  @include page
  .filters
    margin-top: 10px
    button
      margin-left:0px
      @media (max-width: $small)
        margin-top: 20px
    .input, select
      @media (max-width: $small)
        width: 94%
        margin-top: 24px
        margin-left: 8px
      @media (min-width: $small)
        width: 90%
  .list
    overflow: auto
    font-size: 15px
    @media (max-width: $small)
      margin: 23px 6px
    .container
      min-width: 1200px
    .controls
      color: $purple
      font-size: 19px
      .icons
        font-size: 11px
        border-radius: 4px
        padding: 6px
        margin-right: 4px
        &:hover
          background: white
          color: $purple
        i
          margin-right: 3px
          font-size: 12px
        
    .line:hover
      .controls
        color: white
  .historic
    max-height: 400px
    .line
      font-size: 15px
  
</style>